import { AutofillHome } from "components/AutoFill/AutofillHome";
import { AutofillPage } from "components/AutoFill/AutofillPage";
import { DashboardLayout } from "components/DashboardLayout";
import { Header } from "components/DesignSystem/Header/Header";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { Route, Switch, useRouteMatch } from "react-router-dom";

export const AddressBook = () => {
  const { path, url } = useRouteMatch();
  const { isAdmin } = useRoleBasedView();
  const { uuid } = useCurrentGroupContext();
  const breadcrumbs = [
    {
      name: isAdmin ? "Auto-Fill" : "Address Book",
      link: isAdmin ? `/crm/${uuid}/autofills` : `${url}`,
    },
  ];

  return (
    <Switch>
      <Route path={`${path}/addresses`}>
        <AutofillPage type="addresses" customBreadcrumbs={breadcrumbs} />
      </Route>

      <Route path={`${path}/bank_accounts`}>
        <AutofillPage type="bank_accounts" customBreadcrumbs={breadcrumbs} />
      </Route>

      <Route
        path={`${path}/authorized_persons`}
        render={() => (
          <AutofillPage
            type="authorized_persons"
            customBreadcrumbs={breadcrumbs}
          />
        )}
      />
      <Route exact path={path}>
        <DashboardLayout header={<Header v2 title="Address Book" />}>
          <AutofillHome />
        </DashboardLayout>
      </Route>
    </Switch>
  );
};
